
import IconButton from '@mui/material/IconButton';
import InputAdornment from '@mui/material/InputAdornment';
import SearchIcon from '@mui/icons-material/Search';
import SyncIcon from '@mui/icons-material/Sync';
import PropTypes from 'prop-types';


const TextInputSearchButton = (props) => {
    let { position, isLoading, onClick } = props;

    return (
        <InputAdornment position={position}>
           <IconButton disabled={isLoading} 
                  aria-label={
                    isLoading ? 'searching' : 'search'
                  }
                  onClick={onClick}
                > 
            {isLoading ? <SyncIcon /> : <SearchIcon />}
                            </IconButton>

        </InputAdornment>
    )
}

TextInputSearchButton.propTypes = {
    position: PropTypes.string,
    isLoading: PropTypes.bool,
    onClick: PropTypes.func,
};

export default TextInputSearchButton;